import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "../locales/fr.json";

export const resources = {
  fr: {
    translation: fr,
  },
} as const;

export const defaultNS = "translation";

i18n.use(initReactI18next).init({
  fallbackLng: "fr",
  lng: "fr",
  ns: ["translation"],
  defaultNS,
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  resources,
});
